import { styled, LegacyText, TableCell, Stack } from '@gogame/components';

export const SpanNoWrap = styled('span')`
  white-space: nowrap;
  word-wrap: normal;
`;

export const SpanAffectedLevel = styled(LegacyText)`
  margin: 0 0 0 0;
  max-width: 200px;
`;

export const TableCellStatus = styled(
  ({ noBottomBorder: _, isSuccess: __, ...props }) => <TableCell {...props} />
)`
  color: ${(props) =>
    props.isSuccess
      ? props.theme.palette.success.main
      : props.theme.palette.error.main};
  border-bottom: ${({ noBottomBorder }) => noBottomBorder && 0};
`;

export const TableCellFailed = styled(TableCell)`
  color: ${(props) => props.theme.palette.error.main};
`;

export const TextActionDimensionName = styled(LegacyText)`
  max-width: 300px;
`;

export const StackConstStyled = styled(Stack)`
  padding: 4px 0 0;
  min-width: 250px;
`;

export const ImgHolder = styled(Stack)`
  padding: 4px 0 0;
  margin-right: 4px;
`;

export const Img = styled('img')`
  width: 60px;
  height: 35px;
  margin: 0 8px;
  background: red; //#eee;
  box-shadow: 1px 1px 1px 0px rgba(34, 60, 80, 0.5);
`;

export const NoBorderCell = styled(TableCell)`
  border-bottom: 0 !important;
`;

export const ValueContainer = styled('span')`
  margin: 0 0 0 8px;
`;

export const FlexContainer = styled('div')`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
